// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1___94073d0305219e69715","cls2":"Base-cls2__aca80faf58ba068780c9 Base-cls1___94073d0305219e69715"};